// Copyright © 2021 Move Closer

import { Component, Prop } from 'vue-property-decorator'
import { VueConstructor } from 'vue'

import { AbstractModuleUi } from '../_abstract/ui'

import { AdBannerModule, AdBannerVersion } from './AdBanner.contracts'
import { AdBannerGoogle } from './versions/AdBannerGoogle.ui'
import { AdBannerWTG } from './versions/AdBannerWTG.ui'

const adBannerVersionUiComponentRegistry: Record<AdBannerVersion, VueConstructor> = {
  [AdBannerVersion.GoogleAds]: AdBannerGoogle,
  [AdBannerVersion.WayToGrow]: AdBannerWTG
}

/**
 * Component capable of rendering the `AdBannerModule's` contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
@Component<AdBannerModuleUi>({
  name: 'AdBannerModuleUi',
  components: { AdBannerGoogle, AdBannerWTG },

  template: `
    <component :is="bannerComponent" v-bind="$props" />
  `
})
export class AdBannerModuleUi extends AbstractModuleUi<AdBannerModule> {
  @Prop({
    type: Function,
    required: false
  })
  readonly onEmptyCallback: Function | undefined

  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  readonly forceHide!: boolean

  public get bannerComponent () {
    if (!(this.module.version in adBannerVersionUiComponentRegistry)) {
      this.onError(`AdBannerModule.[get]component(): There's no UI component for the given module version!\nFull [this.module] object: ${JSON.stringify(this.module)}`)

      return AdBannerGoogle
    }

    return adBannerVersionUiComponentRegistry[this.module.version]
  }
}
